import gettext from '@sdk/lang/gettext';

import {
  SurveyStepType,
  SurveyCommentStepType,
  SurveyFinishStepType,
} from '@web/components/survey/types/';

export enum SurveySteps {
  reason = 1,
  comment = 2,
  finishCall = 3,
}

export const OTHER_REASON_KEY = 'Other';
export const SLING_REASON_OPTIONS = [
  { value: 'The paid plans are too expensive', label: gettext('The paid plans are too expensive') },
  {
    value: "Don't need any of the paid features",
    label: gettext("Don't need any of the paid features"),
  },
  {
    value: 'All our needs are met by free features',
    label: gettext('All our needs are met by free features'),
  },
  {
    value: 'The paid plans are missing key features',
    label: gettext('The paid plans are missing key features'),
  },
  {
    value: 'Need more time to explore Sling to upgrade',
    label: gettext('Need more time to explore Sling to upgrade'),
  },
  { value: OTHER_REASON_KEY, label: gettext('Other') },
];

export const TOAST_REASON_OPTIONS = [
  { value: 'The Pro plan is too expensive', label: gettext('The Pro plan is too expensive') },
  {
    value: "Don't need any of the Pro features",
    label: gettext("Don't need any of the Pro features"),
  },
  {
    value: 'All our needs are met by the Lite plan',
    label: gettext('All our needs are met by the Lite plan'),
  },
  {
    value: 'The Pro plan is missing essential features',
    label: gettext('The Pro plan is missing essential features'),
  },
  {
    value: 'Need more time to explore Sling to upgrade',
    label: gettext('Need more time to explore Sling to upgrade'),
  },
  { value: OTHER_REASON_KEY, label: gettext('Other') },
];

export const SLING_STEPS_CONFIG = {
  [SurveySteps.reason]: {
    number: 1,
    subtitle: gettext(
      'Which of the following reasons most influenced your decision to remain on the Free plan?'
    ),
    submitLabel: gettext('Next'),
  } as SurveyStepType,
  [SurveySteps.comment]: {
    text: gettext('Tell us more about your reason'),
    number: 2,
  } as SurveyCommentStepType,
  [SurveySteps.finishCall]: {
    title: gettext('Thank you for your input!'),
    subtitle: gettext(
      'We highly value your feedback and use it to keep improving our product. We would love to hear more from you over a call.'
    ),
  } as SurveyFinishStepType,
};

export const TOAST_STEPS_CONFIG = {
  ...SLING_STEPS_CONFIG,
  [SurveySteps.reason]: {
    number: 1,
    subtitle: gettext(
      'Which of the following reasons most influenced your decision to remain on the Lite plan?'
    ),
    subtitleLabel: gettext('next'),
  } as SurveyStepType,
};

export const STEPS_COUNT = 2;

export const BOOK_CALL_URL =
  'https://calendly.com/emily-worthington-sling/30-minute-customer-feedback-chat';
